module.exports = __webpack_public_path__ + "static/media/kiwi.7cb4ca95.svg";